import { Pipe, type PipeTransform, inject } from "@angular/core";
import type { ITranslateObject } from "@app/views-interfaces/translate-object.interface";
import { WkTranslateService } from "./wk-translate.service";

@Pipe({
    name: "wkTranslate",
    pure: false,
})
export class WkTranslatePipe implements PipeTransform {
    private readonly wkTranslateService = inject(WkTranslateService);
    public transform(value: string | ITranslateObject, params?: any): string {
        return this.wkTranslateService.translate(value, params);
    }
}
